import { OrganizationTypes } from '@/common/constants';
import Permissions from '@/common/permissions';
import useHasAccess, { AccessRequirement } from '@/modules/core/hooks/useHasAccess';

const PLANS_ORG_TYPES = [
  OrganizationTypes.system,
  OrganizationTypes.partner,
  OrganizationTypes.distributor,
  OrganizationTypes.subsidiary,
  OrganizationTypes.company,
];

const PLANS_PERMISSIONS = [
  Permissions.VIEW_PLAN,
  Permissions.VIEW_PLAN_TEMPLATE,
  Permissions.PLAN_TEMPLATE_SETUP,
  Permissions.PLAN_SETUP,
  Permissions.EDIT_DRAFT_PLAN,
  Permissions.ACTIVATE_PLAN,
  Permissions.EDIT_ACTIVE_PLAN,
];

export const PLANS_ACCESS_REQUIREMENTS: AccessRequirement[] = PLANS_ORG_TYPES.flatMap((orgType) =>
  PLANS_PERMISSIONS.map((permission) => ({ organizationType: orgType, permission }))
);

export const usePlansAccess = () => useHasAccess(PLANS_ACCESS_REQUIREMENTS);

export const usePlansTabAccess = () =>
  useHasAccess([
    { permission: Permissions.VIEW_PLAN },
    { permission: Permissions.PLAN_SETUP },
    { permission: Permissions.EDIT_DRAFT_PLAN },
    { permission: Permissions.ACTIVATE_PLAN },
    { permission: Permissions.EDIT_ACTIVE_PLAN },
  ]);

export const useTemplatesTabAccess = () =>
  useHasAccess([
    { permission: Permissions.VIEW_PLAN_TEMPLATE },
    { permission: Permissions.PLAN_TEMPLATE_SETUP },
  ]);
